// eslint-disable-next-line import/prefer-default-export
export const disabledClass =
  'bg-greyscale-100 text-greyscale-400 text-black-c cursor-not-allowed'
